import React from "react"

export function useCountdown(): [number, (s: number) => void, number] {
    const [time, setTime] = React.useState(0)

    const ref = React.useRef(0)
    const interval = React.useRef<ReturnType<typeof setInterval> | null>(null)

    React.useEffect(() => {
        return () => {
            interval.current && clearInterval(interval.current)
        }
    }, [])

    const start = (s: number) => {
        interval.current && clearInterval(interval.current)
        ref.current = s
        setTime(s)
        interval.current = setInterval(() => {
            ref.current = ref.current - 1
            setTime(ref.current)
            if (ref.current === 0 && interval.current) clearInterval(interval.current)
        }, 1_000)
    }

    return [time, start, ref.current]
}